const FinancialType = ({type}: IFinancialTypeProps) => {
  return (
    <div className=" mt-7 flex justify-between">
      <p className=" text-gray-6">نوع تامین مالی:</p>
      <p className=" text-gray-6">{type}</p>
    </div>
  );
};

export default FinancialType;
